import ActiveController from "rapid/controller";

export class htmlPreviewController extends ActiveController {
  constructor($injector, $rootScope, $element, $scope, $timeout) {
    "ngInject";
    super($injector);

    this.$rootScope = $rootScope;
    this.$element = angular.element($element);
    this.$scope = $scope;
    this.width = 0;
    this.height = 0;
    this.renderedArray = [];
    this.uniqueId = `id-${Math.random()}`;
    this.bgId = `bg-${Math.random()}`;
    this.overlayId = `overlay-${Math.random()}`;
    this.boomerangId = `boomerang-${Math.random()}`;
    this.$timeout = $timeout;
    this.boomerangCount = null;

    $scope.$watch(
      () => this.areas,
      () => {
        let divider = Number(this.index);
        try {
          this.areas = JSON.parse(this.areas);
          this.renderedArray = [];
          this.areas &&
            Object.keys(this.areas).forEach((area) => {
              if (
                (!this.areas[area].x && this.areas[area].x !== 0) ||
                (!this.areas[area].y && this.areas[area].y !== 0)
              ) {
                return false;
              }
              let el = {};
              // Basic values
              if (!this.relatedValues) {
                el = {
                  x: Math.round(this.areas[area].x / divider) + "px",
                  y: Math.round(this.areas[area].y / divider) + "px",
                  width: this.areas[area].width
                    ? Math.round(this.areas[area].width / divider) + "px"
                    : 0,
                  height: this.areas[area].height
                    ? Math.round(this.areas[area].height / divider) + "px"
                    : 0,
                };
              } else {
                el = {
                  x: this.areas[area].x,
                  y: this.areas[area].y,
                  width:
                    (((this.areas[area].width / 100) * this.prHeight) /
                      this.prWidth) *
                    100,
                  height: this.areas[area].height,
                };
                el.x -= el.width / 2;
                el.y -= el.height / 2;
                el.width += "%";
                el.height += "%";
                el.x += "%";
                el.y += "%";
              }

              // Gif background
              switch (area) {
                case "single":
                  if (this.hidePhotoIcon) {
                    el.hide = true;
                  }
                  el.gif = require("../../../../images/photo.gif");
                  el.titleBtn = "Photo";
                  break;
                case "gif":
                  if (this.hideGifIcon) {
                    el.hide = true;
                  }
                  el.gif = require("../../../../images/gif.gif");
                  el.titleBtn = "Gif";
                  break;
                case "boomerang":
                  if (this.hideBoomerangIcon) {
                    el.hide = true;
                  }
                  el.gif = require("../../../../images/boomerang.gif");
                  el.titleBtn = "Boomerang";
                  break;
                case "video":
                  if (this.hideVideoIcon) {
                    el.hide = true;
                  }
                  el.gif = require("../../../../images/boomerang.gif");
                  el.titleBtn = "Video";
                  break;
                case "trueVideo":
                  if (this.hideVideoIcon) {
                    el.hide = true;
                  }
                  el.gif = require("../../../../images/boomerang.gif");
                  el.titleBtn = "Video";
                  break;
              }

              // Image background
              if (this.areas[area].image) {
                if (this.single) {
                  el.image = require("../../../../images/photo.png");
                } else if (!this.areas[area].title) {
                  el.image = require("../../../../images/1.png");
                } else {
                  if (this.boomerang) {
                    el.image = require(`../../../../images/boomerang-frames/b${
                      this.areas[area].title[0] * 30
                    }.png`);
                  } else {
                    el.image = require(`../../../../images/${this.areas[area].title[0]}.png`);
                  }

                  if (this.video) {
                    el.image = require(`../../../../images/boomerang-frames/b${
                        this.areas[area].title[0] * 30
                    }.png`);
                  } else {
                    el.image = require(`../../../../images/${this.areas[area].title[0]}.png`);
                  }

                  let mainSide =
                    this.areas[area].height < this.areas[area].width
                      ? "height"
                      : "width";
                  el.title = this.areas[area].title;
                  el.font =
                    Math.round((this.areas[area][mainSide] / divider) * 0.55) +
                    "px";
                }
              } else if (this.areas[area].gif) {
                this.drawGif([1, 2, 3]);
                el.frames = true;
              } else if (this.areas[area].video) {
                el.video = true;
              } else if (this.areas[area].trueVideo) {
                el.trueVideo = true;
              }
              el.angle = this.areas[area].angle + "deg";
              el.videoSrc = null;
              el.videoTag = false;

              // Mark config areas for multi-config feature
              if (area.startsWith("config")) {
                el.isConfig = true;
              }

              // Keep custom title available for all area types (including customIcon areas)
              if (this.areas[area].title !== undefined && this.areas[area].title !== null) {
                el.title = this.areas[area].title;
                el.font = this.areas[area].font || "14px";
              }

              // Handle customIcon: can be an attachment object or a string
              if (this.areas[area].customIcon) {
                const customIcon = this.areas[area].customIcon;
                // Check if customIcon is an object (after JSON.parse it should be)
                if (customIcon && typeof customIcon === "object") {
                  // It's an attachment object - check for attachment_file or thumbnail_file
                  const file = customIcon.attachment_file || customIcon.thumbnail_file;
                  if (file) {
                    el.customIcon = {attachment_file: file};
                    if (/\.(mp4|mov|webm)$/i.test(file)) {
                      el.videoSrc = file;
                      el.videoTag = true;
                    }
                  }
                } else if (typeof customIcon === "string" && customIcon.length > 0) {
                  // It's a string URL
                  el.customIcon = {attachment_file: customIcon};
                  if (/\.(mp4|mov|webm)$/i.test(customIcon)) {
                    el.videoSrc = customIcon;
                    el.videoTag = true;
                  }
                }
              }
              // If trueVideo and still no videoSrc, try direct link from area
              if (el.trueVideo && !el.videoSrc) {
                const directVideo = this.areas[area].video || this.areas[area].trueVideo;
                if (directVideo && typeof directVideo === "string" && /\.(mp4|mov|webm)$/i.test(directVideo)) {
                  el.videoSrc = directVideo;
                  el.videoTag = true;
                }
              }

              this.renderedArray.push(el);
            });
        } catch (e) {
          //
        }
      }
    );

    $scope.$watch(
      () => this.prWidth,
      () => {
        this.changeSize();
        this.changeLogoPosition();
      }
    );

    $scope.$watch(
      () => this.prHeight,
      () => {
        this.changeSize();
        this.changeLogoPosition();
      }
    );

    $scope.$watch(
      () => this.index,
      () => {
        this.changeSize();
      }
    );

    //  On DPI change, recalculate bleed for new formats
    $scope.$watch(
      () => this.printDpi,
      () => {
        this.changeSize();
      }
    );

    $scope.$watch(
      () => this.videoTime,
      () => {
        this.makeBoomerang();
      }
    );

    $scope.$watch(
      () => this.videoSpeed,
      () => {
        this.makeBoomerang();
      }
    );

    $scope.$watch(
      () => this.background,
      () => {
        this.animateBackground();
      }
    );

    $scope.$watch(
      () => this.overlay,
      () => {
        this.animateOverlay();
      }
    );
    $scope.$watch(
      () => this.animationSpeed,
      () => {
        this.animateOverlay();
        this.animateBackground();
      }
    );
    $scope.$watch(
      () => this.logo,
      () => {
        this.setUpLogo();
      }
    );
    $scope.$watch(
      () => this.logoSize,
      () => {
        this.setUpLogo();
      }
    );
    $scope.$watch(
      () => this.logoPosition,
      () => {
        this.setUpLogo();
      }
    );
    $scope.$watch(
      () => this.strip,
      () => {
        this.changeLogoPosition();
      }
    );
    $scope.$watch(
        () => this.videoOverlay
    );
    $scope.$watch(
        () => this.aiFeature
    );
    $scope.$watch(() => this.aiOverlay);
  }

  $onInit() {
    this.changeSize();
    this.liveViewVideo = require(`../../../../images/short-preview.mp4`);
    this.portraiteVideoModeVideo = require(`../../../../images/video-preview-portraite.mp4`);
    this.landscapeVideoModeVideo = require(`../../../../images/video-preview-lanscape.mp4`);
  }

  $onDestroy() {
    clearInterval(this.count);
    clearInterval(this.countBackground);
    clearInterval(this.countOverlay);
    clearInterval(this.boomerangCount);
  }

  changeSize() {
    this.width = Math.round(Number(this.prWidth) / Number(this.index)) + "px";
    this.height = Math.round(Number(this.prHeight) / Number(this.index)) + "px";

    const w = Number(this.prWidth);
    const h = Number(this.prHeight);
    const idx = Number(this.index);
    //  4 old pairs — legacy bleed; for A1–A6, 10×15, 15×20: bleedPx = 3mm from DPI
    const OLD_PAIRS = [[2520, 1890], [1844, 1240], [1890, 2520], [1240, 1844]];
    const isOldPair = OLD_PAIRS.some(([a, b]) => w === a && h === b);
    const dpi = this.printDpi ? Number(this.printDpi) : 300;

    if (!isOldPair && dpi > 0) {
      const bleedPx = Math.round((3 / 25.4) * dpi); // 3mm in pixels
      this.bleed = {
        width: (w - 2 * bleedPx) / idx + "px",
        height: (h - 2 * bleedPx) / idx + "px",
        top: bleedPx / idx + "px",
        left: bleedPx / idx + "px",
      };
    } else if (w > h) {
      if (w === 2520 && h === 1890) {
        this.bleed = { width: 2476 / idx + "px", height: 1850 / idx + "px", top: 20 / idx + "px", left: 22 / idx + "px" };
      } else {
        this.bleed = { width: 1800 / idx + "px", height: 1200 / idx + "px", top: 22 / idx + "px", left: 20 / idx + "px" };
      }
    } else {
      if (w === 1890 && h === 2520) {
        this.bleed = { width: 1846 / idx + "px", height: 2476 / idx + "px", top: 22 / idx + "px", left: 20 / idx + "px" };
      } else {
        this.bleed = { width: 1200 / idx + "px", height: 1800 / idx + "px", top: 20 / idx + "px", left: 22 / idx + "px" };
      }
    }
  }

  drawGif(frames) {
    clearInterval(this.count);
    let idx = 0;
    this.gifFrame = require(`../../../../images/${frames[idx]}.png`);

    this.count = setInterval(
      () => {
        this.gifFrame = require(`../../../../images/${frames[idx]}.png`);
        this.$scope.$apply(() => this.gifFrame);
        if (idx === frames.length - 1) {
          idx = 0;
        } else {
          idx++;
        }
      },
      this.gifSpeed ? (Number(this.gifSpeed) / frames.length) * 1000 : 667
    );
  }

  // checkOverflow() {
  //     let el = document.getElementById(this.uniqueId);
  //     this.isOverflow = el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;
  // }

  makeBoomerang() {
    clearInterval(this.boomerangCount);
    const allFiles = 120;
    const framesPerSecond = 24;
    let time = this.videoTime <= 5 ? this.videoTime || 1.5 : 5; // Added mock for preview to be 5 seconds even if video time is longer (up to 8s);
    let speed = this.videoSpeed || 1.5;
    let startCount = allFiles - time * 24;
    let direction = "forward";
    let idx = 0;
    let speedIndex = (time * 2) / speed;
    let imagesArr = [];
    let loadedImages = 0;

    let onImageLoad = () => {
      loadedImages++;
      clearInterval(this.boomerangCount);
      if (loadedImages === imagesArr.length) {
        clearInterval(this.boomerangCount);
        this.boomerangCount = setInterval(() => {
          this.boomerangFrame = imagesArr[Math.floor(idx)]
            ? imagesArr[Math.floor(idx)].src
            : "";
          this.$scope.$apply(() => this.boomerangFrame);
          if (idx >= imagesArr.length && direction === "forward") {
            direction = "backward";
          } else if (idx <= 0 && direction === "backward") {
            direction = "forward";
          } else {
            direction === "forward" ? (idx += speedIndex) : (idx -= speedIndex);
          }
        }, 1000 / framesPerSecond);
      }
    };

    for (let i = startCount; i <= 120; i++) {
      let img = new Image();
      img.src = require(`../../../../images/boomerang-frames/b${Math.floor(
        i
      )}.png`);
      img.onload = () => {
        onImageLoad();
      };
      imagesArr.push(img);
    }
  }

  animateBackground() {
    setTimeout(() => {
      try {
        let arr = JSON.parse(this.background);
        let pr = document.getElementById(this.bgId);
        if (!pr) return;
        let images = [];
        for (let i = 0; i < arr.length; i++) {
          let image = new Image();
          image.src = arr[i];
          arr[i] = images.push(image);
        }
        clearInterval(this.countBackground);
        if (arr.length > 1) {
          let idx = 0;
          this.countBackground = setInterval(
            () => {
              pr.style.backgroundImage = `url(${images[idx].src})`;
              if (idx === arr.length - 1) {
                idx = 0;
              } else {
                idx++;
              }
            },
            this.animationSpeed
              ? (Number(this.animationSpeed) / arr.length) * 1000
              : 1000
          );
        } else {
          arr.length
            ? (this.background = images[0].src)
            : (this.background = null);
        }
      } catch (e) {
        //console.log(e);
      }
    });
  }

  animateOverlay() {
    setTimeout(() => {
      try {
        let arr = JSON.parse(this.overlay);
        let pr = document.getElementById(this.overlayId);
        let images = [];
        for (let i = 0; i < arr.length; i++) {
          let image = new Image();
          image.src = arr[i];
          arr[i] = images.push(image);
        }
        clearInterval(this.countOverlay);
        if (arr.length > 1) {
          let idx = 0;
          this.countOverlay = setInterval(
            () => {
              pr.style.backgroundImage = `url(${images[idx].src})`;
              if (idx === arr.length - 1) {
                idx = 0;
              } else {
                idx++;
              }
            },
            this.animationSpeed
              ? (Number(this.animationSpeed) / arr.length) * 1000
              : 1000
          );
        } else {
          arr.length ? (this.overlay = images[0].src) : (this.overlay = null);
        }
      } catch (e) {
        //console.log(e);
      }
    });
  }

  setUpLogo() {
    const WIDTH_MULTIPLIER = 2.4;
    const MAX_SIZE = 30;

    this.logoStyle = {
      width: this.logoSize * WIDTH_MULTIPLIER + "%",
      height: this.logoSize + "%",
    };

    if (this.logoPosition <= 3) {
      this.logoStyle.top = `${5 + (MAX_SIZE - this.logoSize) / 2}%`;
    } else {
      this.logoStyle.bottom = `${5 + (MAX_SIZE - this.logoSize) / 2}%`;
    }

    if (this.logoPosition === 1 || this.logoPosition === 4) {
      this.logoStyle.left = "4%";
      this.logoStyle.width = this.logoSize * (WIDTH_MULTIPLIER / 2) + "%";
    } else if (this.logoPosition === 3 || this.logoPosition === 6) {
      this.logoStyle.right = "4%";
      this.logoStyle.width = this.logoSize * (WIDTH_MULTIPLIER / 2) + "%";
    } else if (this.logoPosition === 2 || this.logoPosition === 5) {
      this.logoStyle.left = `${50 - this.logoSize * (WIDTH_MULTIPLIER / 2)}%`;
    }
  }

  changeLogoPosition() {
    if (this.prHeight > this.prWidth && this.strip === "false") {
      this.logosArr = [
        {
          width: "75%",
          left: "12.5%",
          bottom: "6%",
          height: "15%",
        },
      ];
    } else if (this.prHeight > this.prWidth && this.strip === "true") {
      this.logosArr = [
        {
          bottom: "2.5%",
          height: "10%",
          width: "40%",
          left: "5%",
        },
        {
          bottom: "2.5%",
          height: "10%",
          width: "40%",
          right: "5%",
        },
      ];
    } else if (this.prHeight < this.prWidth && this.strip === "false") {
      this.logosArr = [
        {
          width: "75%",
          left: "12.5%",
          bottom: "6%",
          height: "15%",
        },
      ];
    } else if (this.prHeight < this.prWidth && this.strip === "true") {
      this.logosArr = [
        {
          bottom: "52.5%",
          height: "10%",
          width: "75%",
          left: "12.5%",
        },
        {
          bottom: "2.5%",
          height: "10%",
          width: "75%",
          left: "12.5%",
        },
      ];
    }
  }
  isVideo(name) {
    if (name === undefined || name === null) {
      return false;
    } else {
      return (
        name.indexOf(".mp4") !== -1 ||
        name.indexOf(".webm") !== -1 ||
        name.indexOf(".mov") !== -1
      );
    }
  }

  setOpacity(tr) {
    if (!this.transparency || !this.transparency.enabled) {
      return 1;
    }
    return tr / 100;
  }
  checkForNullInUrl(url) {
    // Перевіряємо, чи передано URL, інакше повертаємо false
    if (!url || typeof url !== "string") {
      return false;
    }

    // Перевіряємо наявність 'null' у рядку
    const containsNull = url.includes("null");
    return containsNull;
  }

  hasBackgroundImage(url) {
    if (!url || typeof url !== "string") {
      return false;
    }

    const normalized = url.trim();
    if (!normalized) {
      return false;
    }

    return !this.checkForNullInUrl(normalized);
  }

  getLogoHeight() {
    return ((this.prHeight / this.index) /100)*20 + "px";
  }
}



// WEBPACK FOOTER //
// ./sources/components/common/html-preview/html-preview.controller.js